import { OrganizationUserDetailsState } from "@idw-types/state/organization-user-details-state";
import { getOrganizationUserDetailsState } from "@redux/selectors/root-selectors";
import { createSelector } from "reselect";

export const getOrganizationUserDetailsDataState = createSelector(getOrganizationUserDetailsState, (state: OrganizationUserDetailsState) => {
    return {
        isLoadingAxnAdminUser: state.organizationUser.isLoading,
        axnAdminUser: state.organizationUser.organizationUser
    };
});